/**
 * Convocazione a provino: composizione testo e invio.
 * L'invio va a un servizio esterno (webhook Make/n8n/Zapier o EmailJS) che
 * spedisce la mail e aggiorna il "plan provini". Se il webhook non è
 * configurato, si usa il fallback `mailto:` (apre il client di posta dell'utente).
 */

// Testo di default della convocazione a partire dai dati del provino.
export const buildConvocationText = ({
	playerName,
	dateStr,
	timeStr,
	place,
	categoryLabel,
}) => {
	const subject = `Convocazione provino${playerName ? " — " + playerName : ""}`;
	const body = [
		"Gentili,",
		"",
		`con la presente si comunica che ${playerName || "il giocatore"} è convocato/a per un provino${
			categoryLabel ? ` (categoria ${categoryLabel})` : ""
		}:`,
		"",
		`• Data: ${dateStr || "—"}`,
		`• Ora: ${timeStr || "—"}`,
		`• Luogo: ${place || "—"}`,
		"",
		"Si prega di confermare la presenza.",
		"",
		"Cordiali saluti,",
		"Settore Giovanile",
	].join("\n");
	return {subject, body};
};

// Link mailto (fallback): apre il client di posta già compilato.
export const buildMailto = ({to = [], cc = [], subject = "", body = ""}) => {
	const params = new URLSearchParams();
	if (cc.length) params.set("cc", cc.join(","));
	if (subject) params.set("subject", subject);
	if (body) params.set("body", body);
	return `mailto:${to.join(",")}?${params.toString()}`;
};

// Invio al servizio esterno (webhook Make/n8n/Zapier). Ritorna true se accettato.
export const sendConvocationWebhook = async (url, payload) => {
	const response = await fetch(url, {
		method: "POST",
		headers: {"Content-Type": "application/json"},
		body: JSON.stringify(payload),
	});
	return response.ok;
};

// Invio via EmailJS (REST API, funziona dal browser). Ritorna true se accettato.
// I nomi delle variabili (to_email, cc_email, subject, message, player_name)
// devono corrispondere a quelli usati nel template EmailJS.
export const sendConvocationEmailJS = async ({
	serviceId,
	templateId,
	publicKey,
	to = [],
	cc = [],
	subject,
	body,
	playerName,
}) => {
	const response = await fetch(
		"https://api.emailjs.com/api/v1.0/email/send",
		{
			method: "POST",
			headers: {"Content-Type": "application/json"},
			body: JSON.stringify({
				service_id: serviceId,
				template_id: templateId,
				user_id: publicKey,
				template_params: {
					to_email: to.join(","),
					cc_email: cc.join(","),
					subject: subject || "",
					message: body || "",
					player_name: playerName || "",
				},
			}),
		},
	);
	return response.ok;
};
